/**
 * CartStateSection — surfaces whatever the active CartProvider has written
 * into `window.__PCB_DEBUG_EXTRA__.cart` (RAO/RCM/RAM are responsible for
 * that wiring; the panel itself doesn't reach into CartContext because the
 * panel mounts at the shell level where Cart isn't in scope).
 */
import { DebugJson, DebugSection } from '../DebugSection';

export interface CartStateSectionProps { searchTerm?: string }

export function CartStateSection({ searchTerm }: CartStateSectionProps): JSX.Element {
  const extra = (typeof window !== 'undefined' && window.__PCB_DEBUG_EXTRA__) || {};
  const cart = extra['cart'];
  const onCartRoute = typeof window !== 'undefined' && /\/(rao|rcm|ram|rim|rcd|rsm)\b/i.test(window.location.pathname);

  return (
    <DebugSection
      id="cart"
      title="2. Cart state"
      searchTerm={searchTerm}
      defaultCollapsed={!onCartRoute && !cart}
    >
      {cart ? (
        <DebugJson value={cart} searchTerm={searchTerm} />
      ) : (
        <div className="pcb-debug-empty">
          {onCartRoute
            ? 'CartProvider has not registered debug data yet — the active module should expose state via window.__PCB_DEBUG_EXTRA__.cart.'
            : 'Not on a cart route. Open RAO/RCM/RAM/RIM/RCD/RSM to populate.'}
        </div>
      )}
    </DebugSection>
  );
}
